import { CONTROL_NAME, controlsForDisplay } from './types'

export const EXCLUDED_TYPES = [
  CONTROL_NAME.PRODUCT_SELECTION_CONTROL,
  CONTROL_NAME.ENTITY_LOOKUP_CONTROL,
  ...controlsForDisplay
]
